import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'rich-text',
  name: '富文本',
  icon: '文',
  group: '基础组件',
  description: '展示安全富文本内容',
  defaultProps: {
    html: '<p>请输入内容</p>'
  }
}
